export function formatDateTime(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  const d = date.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit' });
  const t = date.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' });
  return `${d} ${t}`;
}

export function formatDateTimeWithSeconds(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  const d = date.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit' });
  const t = date.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  return `${d} ${t}`;
}

export function getCountdown(isoString, now) {
  if (!isoString) return '';
  const diff = Math.max(0, Math.floor((new Date(isoString).getTime() - now) / 1000));
  const m = String(Math.floor(diff / 60)).padStart(2, '0');
  const s = String(diff % 60).padStart(2, '0');
  return `${m}:${s}`;
}
